import React, { useState } from 'react'
import img from './home-img/Screenshot_17-12-2024_224833_-removebg-preview (1).png'
import './Home.css'
import vid from './home-img/vid.gif'
import vid1 from './home-img/2-25-939x1024.jpg'
// import { Link } from 'react-scroll'
import { useNavigate } from 'react-router-dom'
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import Nav from '../nav/nav'

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen)
  };
  // const navigate = useNavigate();

  // const handleclick = () => {
  //   navigate('/product')
  // }

  return (
    <div className='home-main'>
      <Nav />
      {/* <div className="nav-main">

        <div className="logo">
          <img src={img} alt="" />
        </div>
        <div className="label" onClick={toggleMenu}>
          {isOpen ? (
            // Close icon (an "X")
            <i class="fa-solid fa-x" id='cancel'></i>
          ) : (
            // Hamburger icon (three bars)
            <i class="fa-solid fa-bars" id='btn'></i>
          )}
        </div>

        {/* <div className="pages"> */}
        {/* <div className={`pages ${isOpen ? 'open' : ''}`}>
          <i class="fa-solid fa-x" id='cancel' onClick={toggleMenu}></i>
          <p><ScrollLink to="homee" smooth offset={-100}>Home</ScrollLink></p>
          <p><ScrollLink to="about" smooth offset={-100}>About Us</ScrollLink></p>
          <p><ScrollLink to="service" smooth offset={-100}>Service</ScrollLink></p>

          <p><RouterLink to="/product">Product</RouterLink></p>

          <p >Cart</p> */}


          {/* <p>Blog</p> */}
          {/* <p>Contact Us</p> */}
        {/* </div> */}
        {/* <div className="qout">
          <ScrollLink spy={true} smooth={true} offset={-100} to='footer'><button> Contact</button></ScrollLink> */}
        {/* </div> */}
      {/* </div> */} 
      
      {/* .................................................. Home ............................................. */}
      <div className="home" id='homee'>
        <div className="home-contents">
          <div className="contents-head" data-aos="fade-up">
            <p>Keep Powered Up with Our Charging
              Solutions</p>
          </div>
          <div className="home-content" data-aos="fade-up">
            <p> AIZO Plug is a top EV charging solution provider in India, established in 2015. We design,
              manufacture, and install efficient charging stations for homes and businesses. Our mission is to
              make EV charging easy, fast, and accessible, supporting the adoption of electric mobility and
              promoting a sustainable, greener future for India.</p>
          </div>
        </div>
        <div className="home-vid">
          <a href="#" data-aos="fade-up"><img src={vid1} alt="" /></a>

        </div>
      </div>
    </div>
  )
}

export default Home